export default "__VITE_ASSET__ec8917e0__"